import * as types from '../mutations-types'
const state = {
  project_status: '',
  project_layout_change: '',
  m_c_a_save_success: {}, // 备忘录，自定义，审批等新建保存
  m_c_a_quote_success: {} // 备忘录，自定义，审批等关联
}
// const getters = {
//   project_status: state => state.project_status
// }
const actions = {}
const mutations = {
  [types.PROJECT_STATUS](state, projectStatus) {
    state.project_status = projectStatus
  },
  [types.PROJECT_LAYOUT_CHANGE](state, projectLayoutChange) {
    state.project_layout_change = projectLayoutChange
  },
  [types.M_C_A_SAVE_SUCCESS](state, data) {
    state.m_c_a_save_success = data
  },
  [types.M_C_A_QUOTE_SUCCESS](state, data) {
    state.m_c_a_quote_success = data
  }
}
export default {
  state,
  // getters,
  actions,
  mutations
}
